export function validateStep(stepElement, stepNumber) {
  // Clear any existing validation messages
  stepElement.querySelectorAll('.validation-message').forEach((msg) => {
    msg.style.display = 'none';
  });

  let isValid = true;

  switch (stepNumber) {
    case 1:
      // Check if product type is selected
      if (!Alpine.store('productForm').selectedProductType) {
        stepElement.querySelector('.validation-message').style.display =
          'block';
        isValid = false;
      }
      break;

    case 2:
      // Check name field
      const nameInput = stepElement.querySelector('[name="name"]');
      if (!nameInput.value.trim()) {
        nameInput
          .closest('.form-group')
          .querySelector('.validation-message').style.display = 'block';
        isValid = false;
      }

      // Check unit count field
      const unitCountInput = stepElement.querySelector('[name="unit_count"]');
      if (!unitCountInput.value || unitCountInput.value < 1) {
        unitCountInput
          .closest('.form-group')
          .querySelector('.validation-message').style.display = 'block';
        isValid = false;
      }
      break;

    case 3:
      // Check if at least one rate set is selected
      const selectedOptions =
        Alpine.store('productForm').selectedRateSetOptions;
      if (!selectedOptions || selectedOptions.length === 0) {
        // Try to find the validation message in the step3 container
        const validationMessage = stepElement.querySelector(
          '.listing-validation-message',
        );
        if (validationMessage) {
          validationMessage.style.display = 'block';
        } else {
          console.warn('Validation message element not found in step 3');
        }
        isValid = false;
      }
      break;
  }

  return isValid;
}

function validateStep1(step) {
  let isValid = true;

  const productBoxes = step.querySelectorAll('.selectable-box');

  // Check the value in the Alpine's store
  const selectedType = Alpine.store('productForm').selectedProductType;

  if (!selectedType) {
    isValid = false;
    productBoxes.forEach((box) => box.classList.add('is-invalid'));
  } else {
    productBoxes.forEach((box) => box.classList.remove('is-invalid'));
  }

  return isValid;
}

function validateStep2(step) {
  let isValid = true;
  // Used to have logic to validate Producttype (AccommodationType or TourType)
  // But they have been moved to Rate (Soldas) instead.
  // keeping this step in case we need to do validation on this step in future

  return isValid;
}

function validateStep3(step) {
  let isValid = true;

  // Validate multi-select for 'rate_set'
  const soldAsSelect = step.querySelector('select[name="rate_set"]');

  if (soldAsSelect && soldAsSelect.selectedOptions.length === 0) {
    isValid = false;
    soldAsSelect.classList.add('is-invalid');
  } else if (soldAsSelect) {
    soldAsSelect.classList.remove('is-invalid');
  }

  return isValid;
}
